<template>
  <div class="pagination-container">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :layout="layout"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :current-page.sync="curPage"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import common from '@/utils/common'

export default {
  data() {
    return {
      moduleName: 'contact',
      pageSizes: common.pagination.pageSizes,
      layout: common.pagination.layout
    }
  },
  computed: {
    pageSize() {
      return this.handleStateGetter('listQuery.params.pageSize')
    },
    total() {
      return this.handleStateGetter('dataList.total')
    },
    curPage: {
      set (val) {
        this.$store.commit(`${this.moduleName}/SET_LIST_QUERY`, { pageNum: val })
      },
      get () {
        return this.handleStateGetter('listQuery.params.pageNum')
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.updateQueryAndData({
        pageNum: 1,
        pageSize: val
      })
    },
    handleCurrentChange(val) {
      this.updateQueryAndData({
        pageNum: val
      })
    },
    updateQueryAndData(query) {
      this.$store.commit(`${this.moduleName}/SET_LIST_QUERY`, query)
      this.$store.dispatch(`${this.moduleName}/GetList`)
    },
    handleStateGetter(k) {
      return eval(`this.$store.state.${this.moduleName}.${k}`)
    }
  }
}
</script>
